import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CredentialStatusLabelColor } from 'src/app/shared/models/credential/customPersonCredentialStatusDefinition.model';
import { PortalCredentialModel } from 'src/portal/pages/credentials/credentials.models';
import { CredentialsService } from 'src/portal/pages/credentials/credentials.service';

@Component({
  selector: 'app-portal-in-progress-credential',
  templateUrl: './portal-in-progress-credential.component.html',
  styleUrls: ['./portal-in-progress-credential.component.scss'],
  standalone: false
})
export class PortalInProgressCredentialComponent implements OnInit {
  credentials: PortalCredentialModel[] = [];
  CredentialStatusLabelColor = CredentialStatusLabelColor;
  @Output() loaded = new EventEmitter<void>();
  constructor(private credentialsService: CredentialsService) {}
  async ngOnInit(): Promise<void> {
    this.credentials = await this.credentialsService.getInProgressCredentials();
    this.loaded.emit();
  }

  getColor(credential: PortalCredentialModel): string {
    return (
      CredentialStatusLabelColor[credential.application?.customApplicationStatus?.color] ||
      CredentialStatusLabelColor[credential.credentialStatus.color]
    );
  }
  getLabel(credential: PortalCredentialModel): string {
    return (
      credential.application?.customApplicationStatus?.label || credential.credentialStatus.label
    );
  }
}
